import { graphql } from "gatsby";
import cx from "classnames";
import React from "react";

import { trackCustomEvent } from "../../utilities/analytics";
import GatsbyImage from "../GatsbyImage";
import { ImageLinkGridDataFragment } from "../../../graphql-types";

const FL_GA_EVENT_CATEGORY = "Engagement";
const FL_GA_EVENT_ACTION = "Link Click";

const ImageLinkGrid = ({ imageLinks }: ImageLinkGridDataFragment) => {
  return (
    <section className="max-w-container mx-auto mt-10">
      <div
        className={cx("grid-cols-2 grid gap-4 brands-matrix", {
          "md:grid-cols-3": imageLinks.length > 4,
          "lg:mx-60": imageLinks.length < 5,
          "lg:mx-40": imageLinks.length > 4,
        })}
      >
        {imageLinks.map(({ url, image, caption, id }) => (
          <figure key={id} style={{ boxShadow: "1px 1px 0 #fff" }}>
            <a
              onClick={() =>
                trackCustomEvent({
                  category: FL_GA_EVENT_CATEGORY,
                  action: FL_GA_EVENT_ACTION,
                  label: url,
                })
              }
              href={url}
            >
              <GatsbyImage
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                alt={image.description!}
                image={image.gatsbyImageData}
                className="rounded-lg"
              />
              {caption && (
                <figcaption className="text-md text-center">
                  {caption}
                </figcaption>
              )}
            </a>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default ImageLinkGrid;

export const fragment = graphql`
  fragment ImageLinkGridData on ImageLinkGrid {
    colour
    imageLinks {
      id
      caption
      url
      image {
        description
        gatsbyImageData(width: 480, height: 480)
      }
    }
  }
`;
